__turbopack_context__.v({
  "avatarBlurred": "CandidateCardSpotlight-module__G5pa0G__avatarBlurred",
  "avatarFallback": "CandidateCardSpotlight-module__G5pa0G__avatarFallback",
  "avatarImage": "CandidateCardSpotlight-module__G5pa0G__avatarImage",
  "avatarPanel": "CandidateCardSpotlight-module__G5pa0G__avatarPanel",
  "avatarWrapper": "CandidateCardSpotlight-module__G5pa0G__avatarWrapper",
  "bottom": "CandidateCardSpotlight-module__G5pa0G__bottom",
  "card": "CandidateCardSpotlight-module__G5pa0G__card",
  "cta": "CandidateCardSpotlight-module__G5pa0G__cta",
  "ctaIcon": "CandidateCardSpotlight-module__G5pa0G__ctaIcon",
  "headings": "CandidateCardSpotlight-module__G5pa0G__headings",
  "highlights": "CandidateCardSpotlight-module__G5pa0G__highlights",
  "meta": "CandidateCardSpotlight-module__G5pa0G__meta",
  "metaSeparator": "CandidateCardSpotlight-module__G5pa0G__metaSeparator",
  "moreSkills": "CandidateCardSpotlight-module__G5pa0G__moreSkills",
  "name": "CandidateCardSpotlight-module__G5pa0G__name",
  "recruiterLogo": "CandidateCardSpotlight-module__G5pa0G__recruiterLogo",
  "recruiterLogoPlaceholder": "CandidateCardSpotlight-module__G5pa0G__recruiterLogoPlaceholder",
  "root": "CandidateCardSpotlight-module__G5pa0G__root",
  "skill": "CandidateCardSpotlight-module__G5pa0G__skill",
  "skillEmoji": "CandidateCardSpotlight-module__G5pa0G__skillEmoji",
  "skillLogo": "CandidateCardSpotlight-module__G5pa0G__skillLogo",
  "skillsLabel": "CandidateCardSpotlight-module__G5pa0G__skillsLabel",
  "skillsList": "CandidateCardSpotlight-module__G5pa0G__skillsList",
  "skillsPanel": "CandidateCardSpotlight-module__G5pa0G__skillsPanel",
  "title": "CandidateCardSpotlight-module__G5pa0G__title",
  "top": "CandidateCardSpotlight-module__G5pa0G__top",
});
